import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, share, map } from 'rxjs';
import { JwtService } from './jwt.service';
import { SoeAuthInterface } from '../interfaces/soe-auth.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccessTokenService {
  public accessToken: string;

  constructor(private httpClient: HttpClient, private jwtService: JwtService) {}

  public isAccessTokenInvalid() {
    return this.jwtService.isTokenInvalid(this.accessToken);
  }

  public getAccessToken(): Observable<string> {
    if (this.isAccessTokenInvalid()) {
      const url = environment.integracaoSoeAuth.tokenEndpoint;

      const data = `grant_type=client_credentials&client_id=${environment.integracaoSoeAuth.clientId}&client_secret=${environment.integracaoSoeAuth.clientSecret}`;

      const options = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };

      return this.httpClient.post<SoeAuthInterface>(url, data, options).pipe(
        share(),
        map((data) => {
          const accessToken = data.access_token;

          this.accessToken = accessToken;

          return accessToken;
        })
      );
    }

    return of(this.accessToken);
  }
}
